import React, { useState } from 'react';
import PingMonitor from './PingMonitor';
import Traceroute from './Traceroute';
import SpeedTest from './SpeedTest';
import PortScanner from './PortScanner';
import DNSLookup from './DNSLookup';
import IPInfo from './IPInfo';
import SubnetCalc from './SubnetCalc';
import WhoisLookup from './WhoisLookup';
import LanScanner from './LanScanner';
import MacLookup from './MacLookup';
import PlaylistChecker from './PlaylistChecker';
import WebTerminal from './WebTerminal';
import { useTranslation } from 'react-i18next';
import './DiagnosticTools.css';

const DiagnosticTools = () => {
  const [selectedTool, setSelectedTool] = useState(null);
  const { t } = useTranslation();

  const renderSelectedTool = () => {
    switch (selectedTool) {
      case 'ping': return <PingMonitor />;
      case 'traceroute': return <Traceroute />;
      case 'speedtest': return <SpeedTest />;
      case 'portscan': return <PortScanner />;
      case 'subnet': return <SubnetCalc />;
      case 'dnslookup': return <DNSLookup />;
      case 'whois': return <WhoisLookup />;
      case 'ipinfo': return <IPInfo />;
      case 'lanscan': return <LanScanner />;
      case 'maclookup': return <MacLookup />;
      case 'playlist': return <PlaylistChecker />;
      case 'terminal': return <WebTerminal />;
      default: return null;
    }
  };

  return (
    <div className="diagnostic-tools">
      <h2 className="tool-title">{t("diagnosticTools.title")}</h2>

      <div className="tool-grid">
        <div className="tool-card bg-ping" onClick={() => setSelectedTool('ping')}>
          📶 {t("diagnosticTools.ping")}
        </div>
        <div className="tool-card bg-traceroute" onClick={() => setSelectedTool('traceroute')}>
          🌐 {t("diagnosticTools.traceroute")}
        </div>
        <div className="tool-card bg-speedtest" onClick={() => setSelectedTool('speedtest')}>
          ⚡ {t("diagnosticTools.speedtest")}
        </div>
        <div className="tool-card bg-portscan" onClick={() => setSelectedTool('portscan')}>
          🔍 {t("diagnosticTools.portscan") || "Port Scan"}
        </div>
        <div className="tool-card bg-subnet" onClick={() => setSelectedTool('subnet')}>
          📐 Subnet Calculator
        </div>
        <div className="tool-card bg-dnslookup" onClick={() => setSelectedTool('dnslookup')}>
          🌐 {t("diagnosticTools.dnslookup") || "DNS Lookup"}
        </div>
        <div className="tool-card bg-whois" onClick={() => setSelectedTool('whois')}>
          🔍 WHOIS / ASN
        </div>
        <div className="tool-card bg-ipinfo" onClick={() => setSelectedTool('ipinfo')}>
          📍 {t("diagnosticTools.ipinfo") || "IP Info"}
        </div>
        <div className="tool-card bg-lanscan" onClick={() => setSelectedTool('lanscan')}>
          📡 LAN Scanner
        </div>
        <div className="tool-card bg-maclookup" onClick={() => setSelectedTool('maclookup')}>
          💻 {t("MAC Lookup") || "MAC Lookup"}
        </div>
        <div className="tool-card bg-playlist" onClick={() => setSelectedTool('playlist')}>
          📺 {t("M3U8 Checker") || "M3U8 Checker"}
        </div>
        <div className="tool-card bg-terminal" onClick={() => setSelectedTool('terminal')}>
          💻 {t("Terminal") || "Terminal"}
        </div>
      </div>

      <div className="selected-tool-output">
        {renderSelectedTool()}
      </div>
    </div>
  );
};

export default DiagnosticTools;